import React, { useState } from "react";
import "../components/styles/Login.css";
import Action from "../components/Action";
import LoadSimple from "../components/LoadSimple";

const ResetPassword = ({ server }) => {
    const queryParameters = new URLSearchParams(window.location.search);
    const token = queryParameters.get("token");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(false);
    const [finished, setFinished] = useState(false);

    const handleSubmit = async () => {
        if (password !== confirmPassword) {
            setError(true);
            setMessage("Las contraseñas no coinciden.");
            return;
        }
        if (password.length < 5) {
            setError(true);
            setMessage("La contraseña debe tener al menos 5 caracteres.");
            return;
        }

        setLoading(true);
        setError(false);

        try {
            const response = await fetch(`${server.url}/api/v1/auth/reset-password-confirm`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token: token, new_password: password }),
            });

            const result = await response.json();

            if (response.ok) {
                setFinished(true);
                setMessage("¡Contraseña actualizada correctamente!");
            } else {
                setError(true);
                setMessage(result.detail || result.message || "Error al actualizar.");
            }
        } catch (e) {
            setError(true);
            setMessage("Error de conexión con el servidor.");
        }
        setLoading(false);
    };

    if (!token) {
        return (
            <div className="login-box" style={{ margin: "100px auto", textAlign: "center" }}>
                <h2>Error</h2>
                <p style={{ color: "white" }}>Enlace inválido o incompleto.</p>
                <a href="/" style={{ color: "#03e9f4", marginTop: "20px", display: "inline-block" }}>
                    Volver al Login
                </a>
            </div>
        );
    }

    return (
        <div className="main-login">
            <div className="cont-login rigth-login">
                <div className="cont-img-back">
                    <div className="cont-img">
                        <img
                            src="ciberseguridad-seguritech.png"
                            className="img-show"
                            alt="Logo"
                        />
                    </div>
                    <div className="cont-img">
                        <img src="monitoreo-2.jpeg" className="img-show" alt="Logo" />
                    </div>
                </div>
                <div className="cont-shadow">
                    <img
                        src="SaimonTech_logo_blanco.png"
                        className="logo-login"
                        alt="Logo"
                    />
                </div>
            </div>
            <div className="cont-login left-login">
                <img src="user_login.png" className="img-top" alt="Logo" />
                <div className="card_login">
                    <div className="bg">
                        <div className="login-box">
                            <p>CAMBIAR CONTRASEÑA</p>

                            {!finished ? (
                                // --- FORMULARIO ---
                                (<form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                                    {/* Campo: Nueva Contraseña */}
                                    <div className="user-box">
                                        <input
                                            required
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <label>Nueva Contraseña</label>
                                    </div>
                                    <div className="user-box">
                                        <input
                                            required
                                            type="password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                        <label>Confirmar Contraseña</label>
                                    </div>
                                    <div className="user-box">
                                        {loading ? (
                                            <LoadSimple />
                                        ) : (
                                            <Action
                                                origen="Login"
                                                titulo="ACTUALIZAR CONTRASEÑA"
                                                action={handleSubmit}
                                                disabled={!password || !confirmPassword}
                                            />
                                        )}
                                    </div>
                                </form>)
                            ) : (
                                <div style={{ textAlign: "center", color: "white" }}>
                                    <p style={{ marginBottom: "30px" }}>Tu contraseña ha sido cambiada con éxito.</p>
                                    <a href="/" className="a_demo_four" style={{ display: "inline-block" }}>
                                        <span></span><span></span><span></span><span></span>
                                        Ir a Iniciar Sesión
                                    </a>
                                </div>
                            )}

            {message && (
                <div className="MessageErrorCont" style={{ marginTop: "20px" }}>
                    <div 
                        className="MessageError"
                        style={!error ? { backgroundColor: "rgba(75, 181, 67, 0.2)", borderColor: "#4BB543" } : {}}
                    >
                        <div 
                            className="txtMessageError" 
                            // Color del texto: Verde si es éxito, Rojo (default) o forzado si es error
                            style={{ textAlign: "center", color: error ? "#ff4d4d" : "#4BB543" }}
                        >
                            {message}
                        </div>
                    </div>
                </div>
            )}
                        </div>
                    </div>
                </div>
                <div className="cont-shadow-movil">
                    <img
                        src="SaimonTech_logo_blanco.png"
                        className="logo-login"
                        alt="Logo"
                    />
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;